import moment from 'moment';
import { all, put, takeLatest } from 'redux-saga/effects';
import { getStatusCode } from 'client/ErrorHandler';
import { prepareStatementsToBeExported } from 'store/utils';
import { generateAsyncFile, saveFile } from 'utils/export';
import FileGenerateWorker, {
  GenerateFileType,
} from 'workers/fileGenerator.worker';
import { wrap } from 'comlink';
import { formatCurrency } from 'utils/intl';
import { FileGenerationTypes, SupportedFilesType } from './types';
import FileGenerationActions from './actions';
import { StatementList } from '../statements/types';

const { request, success, failure } = FileGenerationActions;

const generateFile = async (
  statements: StatementList,
  fileType: SupportedFilesType,
  previousDay: string,
  previousDayValue: string,
  totalValue: number
) => {
  const fileName = `${moment().format(
    'YYYY-MM-DD'
  )}-statement-list.${fileType}`;

  const formattedStatements = prepareStatementsToBeExported(statements);

  let generatorPromise: Promise<Blob>;

  const supportsWorker = 'serviceWorker' in navigator;

  if (!supportsWorker) {
    generatorPromise = generateAsyncFile(
      formattedStatements,
      fileType,
      previousDay,
      previousDayValue,
      formatCurrency(totalValue)
    );
  } else {
    const fileGenerateWorkerInstance: Worker = new FileGenerateWorker();
    const fileGenerateWorkerApi: GenerateFileType = wrap(
      fileGenerateWorkerInstance
    );

    generatorPromise = fileGenerateWorkerApi.generateFile(
      formattedStatements,
      fileType,
      previousDay,
      previousDayValue,
      formatCurrency(totalValue)
    );
  }

  return generatorPromise.then((generatedFile: Blob) => {
    saveFile(generatedFile, fileName, fileType === 'csv');
  });
};
export function* downloadFile({
  payload,
}: ReturnType<typeof request>): Generator<any, void, any> {
  try {
    const { fileType, statements, periodStart, previousDayValue } = payload;
    yield generateFile(
      statements,
      fileType,
      moment(periodStart).subtract('1', 'day').format('DD/MM/YYYY'),
      previousDayValue,
      statements[statements.length - 1].Balance
    );

    yield put(success());
  } catch (error) {
    const statusCode = getStatusCode(error);
    yield put(failure(statusCode));
  }
}

export default function* (): Generator<any, void, any> {
  yield all([
    takeLatest(FileGenerationTypes.FileGenerationRequest, downloadFile),
  ]);
}
